/*=========================================================================================
  File Name: moduleBrokerPackageActions.js
  Description: BrokerPackage Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  // addItem({ commit }, item) {
  //   debugger;
  //   var Token={Authorization: 'Bearer ' + localStorage.accessToken};
  //   return new Promise((resolve, reject) => {
  //     axios.post("API/Package/AddNewCountry", item,{headers:Token})
  //       .then((response) => {
  //         commit('ADD_ITEM', Object.assign(item, { ID: response.data.data.Id }))
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },

  fetchDataListItemsBrokers({ commit }) {
    debugger;
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      axios.get("API/BankTransfer/GetNotapprovedTransferesOfBrokers",{headers:Token})
        .then((response) => {
          debugger;
          commit('SET_BankTransfersBrokers', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsServiceProviders({ commit }) {
    debugger;
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      axios.get("API/BankTransfer/GetNotapprovedTransferesOfSPs",{headers:Token})
        .then((response) => {
          debugger;
          commit('SET_BankTransfersSP', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  BankTransfersBrokers({ commit }) {
    debugger;
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      axios.get("API/BankTransfer/GetNotapprovedTransferesOfBrokers",{headers:Token})
        .then((response) => {
          debugger;
          commit('SET_BankTransfersBrokers', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  SearchBankTransfersBrokers({ commit }, search) {
    debugger;
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      
      axios
        .post("API/BankTransfer/SearchBankTransfersBrokers", search,{headers:Token})
        .then(response => {
          resolve(response);
          commit("SET_BankTransfersBrokers", response.data.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  ConfirmTransferBrokers({ commit }, item) {
    debugger;
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      axios.post("API/BankTransfer/ConfirmTransferBrokers", item,{headers:Token})
        .then((response) => {
          commit('Confirm_TransferBrokers', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  ConfirmTransferSPs({ commit }, item) {
    var Token={Authorization: 'Bearer ' + localStorage.accessToken};
    return new Promise((resolve, reject) => {
      axios.post("API/BankTransfer/ConfirmTransferSPs", item,{headers:Token})
        .then((response) => {
          commit('Confirm_TransferSPs', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  // GetItemByID({ commit }, itemid) {
  //   return new Promise((resolve, reject) => {
  //     axios.get("API/Country/GetCountryByID?Id=" + itemid)
  //       .then((response) => {
  //         commit('UPDATE_Country', response.data.Data)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },

  // removeItem({ commit }, item) {
  //   debugger;
  //   var Token={Authorization: 'Bearer ' + localStorage.accessToken};
  //   return new Promise((resolve, reject) => {
  //     axios.delete("API/Country/DeleteCountry?countryId="+item.Id,{headers:Token})
  //       .then((response) => {
  //         commit('REMOVE_ITEM', item.Id)
  //         resolve(response)
  //       })
  //       .catch((error) => { reject(error) })
  //   })
  // },
}
